import axios, { AxiosResponse } from "axios";

export const downloadAttachment = async (fileUrl: string): Promise<Blob> => {
	try {
		const response: AxiosResponse<Blob> = await axios({
			url: fileUrl,
			method: "GET",
			responseType: "blob"
		});

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
